import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLeftMdLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1112 6.2248C12.3553 6.46888 12.3553 6.86461 12.1112 7.10869L9.21985 10.0001L12.1112 12.8915C12.3553 13.1356 12.3553 13.5312 12.1112 13.7753C11.8671 14.0194 11.4714 14.0194 11.2274 13.7753L7.89399 10.442C7.64992 10.1979 7.64992 9.80225 7.89399 9.55816L11.2274 6.2248C11.4714 5.98073 11.8671 5.98073 12.1112 6.2248Z",
		fill: "currentColor"
	})
});
export default SvgCaretLeftMdLine;
